import React from "react";
import "./rsvp.scss";
import logo from "../../assets/images/rsvp/rsvp-logo-white.svg";
import DefaultLayout from "src/layouts";

const RSVPConfirmation: React.FC = () => (
  <DefaultLayout>
    <div className="rsvp-confirmation">
      <img src={logo} alt="RSVP Logo" className="rsvp-logo" />
      <div className="rsvp-text">
        Thank you for your interest in joining the <br />
        <b>RSVP Partner Community</b>.
        <br /><br />
        Our team will review your submission and get back to you soon!
        <br /><br />
        We’re excited about the potential to work together and look forward to connecting soon.
        <br /><br />
        <span className="rsvp-signature">Partnerships at Peoplevine</span>
      </div>
    </div>
  </DefaultLayout>
);

export default RSVPConfirmation;